import { ConfigurationActionTypes, ConfigurationActions, SoftwareConfigurationState } from './types';

const initialState: SoftwareConfigurationState = {
  isDownloadButtonDisabled: true,
};

export const configurationSofwareReducer = (
  state: SoftwareConfigurationState = initialState,
  action: ConfigurationActionTypes,
): SoftwareConfigurationState => {
  switch (action.type) {
    case ConfigurationActions.SET_IS_DOWNLOAD_BUTTTON_DISABLED: {
      return {
        ...state,
        isDownloadButtonDisabled: action.payload
      };
    }
    default:
      return state;
  }
};
